import axios from 'axios'
import {getToken} from '@/utils/auth'
import router from '../router'
import {
  removePower, removeMenu, removeId, removeName, removeToken, removeRole
} from '@/utils/auth'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 1000 * 30 // 请求超时时间
})

let notToken = ['/admin/AdminLogin.action']

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  // if (store.getters.token) {
  let uri = config.url.replace(config.baseURL, '')
  if (notToken.indexOf(uri) === -1) {
    config.headers['token'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  }
  // }
  // console.log('i am request 拦截器') // for debug
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// 响应拦截（配置请求回来的信息）
service.interceptors.response.use(function (response) {
  // 处理响应数据
  let data = response.data
  if (data.status_code === 1001) {
    // window.location.href ='/login'
    removePower()
    removeMenu()
    removeId()
    removeName()
    removeToken()
    removeRole()

    router.push({path: '/login'})
  }
  return response;
}, function (error) {
  // 处理响应失败
  return Promise.reject(error);
});

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js